<template>
  <div>
    <div class="pc">
      <div class="digital">
        <div class="createbutton">
          <p @click="createvideo()">立即生成</p>
          <p @click="jumppage()">创作历史</p>
        </div>
        <div class="microvideoboxright">
          <el-scrollbar>
            <div class="digitalbox">
              <div>
                <div class="titlebox">
                  <div>
                    <p>01.</p>
                    <p>
                      <span>选择一段视频</span>
                      <span>请使用五官清晰的单人正脸视频</span>
                    </p>
                  </div>
                </div>
                <div class="upload">
                  <el-upload
                    class="upload-demo"
                    drag
                    action=""
                    accept="mp4"
                    :http-request="UploadImage"
                    :show-file-list="false"
                  >
                    <div class="uploadbutton">
                      <el-button type="primary"
                        ><i class="el-icon-upload2"></i>上传视频</el-button
                      >
                      <p>或拖拽视频到此处</p>
                    </div>
                  </el-upload>
                  <p class="tip">
                    <i class="el-icon-warning-outline"></i
                    >{{website.web_title}}不会保存你的视频，制作完成即自动删除
                  </p>
                </div>
                <div class="role">
                  <!-- <p class="roletitle">
                        <i class="el-icon-s-opportunity"></i>
                        <span>没有照片？用这些图片试试吧</span>
                    </p> -->
                  <ul class="lists" v-if="list.length > 0">
                    <li
                      @click="listindex = index;dialogVisible=true"
                      v-for="(item, index) in list"
                      :key="index"
                      :class="listindex == index ? 'on' : ''"
                    >
                      <div>
                        <video :src="item" style="width: 100%"></video>
                      </div>
                    </li>
                  </ul>
                  <el-dialog
                    :visible.sync="dialogVisible"
                    :destroy-on-close="true"
                    width="30%">
                    <video v-if="dialogVisible" :src="list[listindex]" style="width: 100%;height:300px" controls autoplay></video>
                  </el-dialog>
                  <!-- <div class="selectbox">
                        <ul>
                            <li>作品去水印</li>
                            <li>
                                <el-switch
                                v-model="watermark">
                                </el-switch>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                卡通适配
                                <el-tooltip class="item" effect="dark" content="如果选择照片是卡通人物，建议勾选" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </li>
                            <li>
                                <el-switch
                                v-model="cartoon">
                                </el-switch>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                说话姿态
                            </li>
                            <li>
                                <el-select v-model="attitude" placeholder="请选择">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </li>
                        </ul>
                    </div> -->
                </div>
              </div>
              <div>
                <div class="titlebox">
                  <div>
                    <p>02.</p>
                    <p>
                      <span>输入让照片说话的内容</span>
                      <span>您可以选择输入文字或上传语音音频</span>
                    </p>
                  </div>
                  <!-- <div>
                        <i class="el-icon-s-opportunity"></i>
                        <span>没有灵感？插入范文</span>
                    </div> -->
                </div>
                <div class="tab">
                  <ul>
                    <li :class="tabindex ? 'on' : ''" @click="tabindex = true">
                      输入文字
                    </li>
                    <li
                      :class="!tabindex ? 'on' : ''"
                      @click="tabindex = false"
                    >
                      上传语音
                    </li>
                  </ul>
                </div>
                <div v-show="tabindex" class="tabbox1">
                  <el-input
                    type="textarea"
                    placeholder="想要照片说些什么内容？请写在这里吧"
                    resize="none"
                    v-model="voiceForm.content"
                    style="height: 167px"
                  >
                  </el-input>
                  <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" >
                        <el-menu-item index="1">阿里云角色</el-menu-item>
                        <el-menu-item index="2">微软角色</el-menu-item>
                        <el-menu-item index="3">科大讯飞</el-menu-item>
                        <el-menu-item index="4">火山引擎角色</el-menu-item>
                    </el-menu> -->
                  <div v-show="activeIndex == 1" class="ali">
                    <ul class="type">
                      <li
                        v-for="(item, index) in alitype"
                        :key="index"
                        :class="alitypeindex == item.id ? 'on' : ''"
                        @click="changeRole(item.id)"
                      >
                        {{ item.title }}
                      </li>
                    </ul>
                    <el-scrollbar>
                      <ul class="usebox">
                        <li
                          v-for="(item, index) in ali"
                          :key="index"
                          :class="voiceForm.model_id == item.id ? 'on' : ''"
                          @click="voiceForm.model_id = item.id"
                        >
                          <div><img :src="item.image" alt="" /></div>
                          <div>{{ item.role_name }}</div>
                          <div>{{ item.description }}</div>
                        </li>
                      </ul>
                    </el-scrollbar>
                    <div class="slider">
                      <p>音量</p>
                      <el-slider
                        v-model="voiceForm.volume"
                        :min="0"
                        :max="100"
                      ></el-slider>
                      <p>{{ voiceForm.volume }}</p>
                    </div>
                    <div class="slider">
                      <p>语速</p>
                      <el-slider
                        v-model="voiceForm.speed"
                        :min="-500"
                        :max="500"
                      ></el-slider>
                      <p>{{ voiceForm.speed }}</p>
                    </div>
                    <div class="slider">
                      <p>语调</p>
                      <el-slider
                        v-model="voiceForm.intonation"
                        :min="-500"
                        :max="500"
                      ></el-slider>
                      <p>{{ voiceForm.intonation }}</p>
                    </div>
                    <p @click="createflie()" class="button">生成语音</p>
                  </div>
                </div>
                <div v-show="!tabindex" class="tabbox2">
                  <el-upload
                    class="upload-demo"
                    :limit="1"
                    drag
                    action=""
                    accept="mp3,wav"
                    :http-request="uploadVoice"
                    :show-file-list="true"
                    :file-list="videoList"
                  >
                    <div class="uploadbutton">
                      <el-button type="primary"
                        ><i class="el-icon-upload2"></i>上传音频</el-button
                      >
                      <p>或拖拽音频到此区域</p>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <div class="mobile">
      <digitalm></digitalm>
    </div>
    <videoplay
      v-if="videoplaystatus"
      @colsevideo="colsevideo"
      :videoid="videoid"
    ></videoplay>
    <voiceplay
      v-if="voiceplaystatus"
      @colsevideo="colsevideo"
      :audioUrl="videoForm.voice_url"
    ></voiceplay>
  </div>
</template>

<script>
import videoplay from "@/components/videoplay";
import voiceplay from "@/components/voiceplay";
import toptab from "@/components/toptab";
import asidebar from "@/components/asidebar";
import digitalm from "@/components/digitalm";
import {
  uploadUploadVideo,
  voiceGetModelList,
  voiceGenerate,
  uploadUploadVoice,
  videoCreate,
  videoDetail,
} from "@/api/video";
export default {
  props: {
    tid: {
      default: 1,
    },
  },
  components: {
    toptab,
    asidebar,
    digitalm,
    videoplay,
    voiceplay
  },
  data() {
    return {
	  website: this.$store.website,
      dialogVisible:false,
      videoid: 1,
      videoList: [],
      voiceplaystatus:false,
      videoplaystatus: false,
      activeIndex: "1",
      textarea: "",
      tabindex: true,
      watermark: false,
      cartoon: false,
      attitude: 0,
      options: [
        {
          value: 0,
          label: "无动作（仅嘴巴说话）",
        },
        {
          value: 1,
          label: "仅眨眼，面部不转动",
        },
        {
          value: 2,
          label: "眨眼 + 面部自然转动",
        },
        {
          value: 3,
          label: "眨眼 + 面部中幅度转动",
        },
        {
          value: 4,
          label: "眨眼 + 面部大幅转动",
        },
      ],
      listindex: 0,
      list: [],
      alitypeindex: 2,
      alitype: [],
      ali: [],
      voiceForm: {
        content: "",
        volume: 50,
        speed: 1,
        intonation: 1,
        model_id: "",
        creation_id: 2, //数字人
      },
      videoForm: {
        content: "",
        tid: "",
        video_url: "",
        voice_url: "",
        creation_id: 1,
      },
    };
  },
  mounted() {
    this.voiceGetModelList();
    this.videoForm.tid = this.tid;
    videoDetail({ id: this.tid }).then((res) => {
      this.list.push(res.data.template.video_url);
    });
  },
  methods: {
    jumppage() {
      this.$router.push({ path: "/history/2" });
    },
    createflie() {
      // this.videoplaystatus=true
    //   if (this.tabindex) {
        if (this.voiceForm.content == "") {
          this.$message.error("文本不能为空");
          return false;
        }
        const loading1 = this.$loading({
          lock: true,
          text: "语音生成中....",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        voiceGenerate(this.voiceForm).then((res) => {
          loading1.close();
          this.videoForm.voice_url = res.data.url;
          this.voiceplaystatus = true
        //   this.createvideo();
        });
    //   } else {
    //     this.createvideo();
    //   }
    },
    createvideo() {
      if(!this.tabindex){
        this.videoForm.voice_url = this.videoList;
      } 
      if(this.videoForm.voice_url==""){
        this.$message.error("语音文件不能为空");
        return false;
      } 
      this.videoForm.content = this.voiceForm.content;
      this.videoForm.video_url = this.list[this.listindex];
      if(this.videoForm.video_url==""){
        this.$message.error("视频文件不能为空");
        return false;
      } 
      videoCreate(this.videoForm).then((res) => {
        this.videoid = res.data.id;
        this.videoplaystatus = true;
        // this.$router.push({ path: '/history/2'});
      });
    },
    colsevideo() {
      this.voiceplaystatus = false;
      this.videoplaystatus = false;
    },
    changeRole(id) {
      this.alitypeindex = id;
      this.voiceGetModelList();
    },
    voiceGetModelList() {
      voiceGetModelList({ cid: this.alitypeindex }).then((res) => {
        this.alitype = res.data.category_list;
        this.ali = res.data.model_list;
        this.voiceForm.model_id = this.ali[0].id;
      });
    },
    uploadVoice(e) {
      const loading2 = this.$loading({
        lock: true,
        text: "文件上传中....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const formData = new FormData();
      formData.append("file", e.file);
      uploadUploadVoice(formData).then((res) => {
        loading2.close();
        this.videoList = res.data.fullurl;
      });
    },
    UploadImage(e) {
      const loading3 = this.$loading({
        lock: true,
        text: "文件上传中....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const formData = new FormData();
      formData.append("file", e.file);
      uploadUploadVideo(formData).then((res) => {
        loading3.close();
        this.list.push(res.data.fullurl);
      });
    },
  },
};
</script>

<style lang="less">
.digital {
  display: flex;
  .createbutton {
    position: absolute;
    top: 12px;
    right: 80px;
    display: flex;
    p:nth-child(1) {
      background-image: linear-gradient(
        106.92deg,
        rgb(16, 197, 254) 14.83%,
        rgb(16, 147, 254) 31.52%,
        rgb(79, 79, 231) 65.11%,
        rgb(182, 12, 185) 91.29%,
        rgb(224, 202, 245) 102.83%
      );
      height: 36px;
      padding: 0 20px;
      border: 0;
      border-radius: 6px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 14px;
    }
    p:nth-child(2) {
      height: 36px;
      padding: 0 20px;
      border: 0;
      border-radius: 6px;
      background-color: rgb(244, 245, 247);
      color: #333;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 20px;
      cursor: pointer;
      font-size: 14px;
    }
  }
  .microvideoboxright {
    background-color: #f4f5f7;
    padding: 30px 20px 0;
    flex: 1 0 10%;
    // width:calc(100vw - 340px);
    > .el-scrollbar {
      height: calc(100vh - 90px);
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }

    .digitalbox {
      display: flex;
      gap: 20px;
      .titlebox {
        display: flex;
        justify-content: space-between;
        div {
          display: flex;
          align-items: center;
          p:nth-child(1) {
            color: #678bfe;
            font-size: 20px;
            font-weight: 700;
            margin-right: 8px;
          }
          p:nth-child(2) {
            span {
              display: block;
            }
            span:nth-child(1) {
              font-size: 20px;
              font-weight: 700;
              margin-bottom: 4px;
              margin-bottom: 4px;
            }
            span:nth-child(2) {
              color: #999;
              font-size: 14px;
            }
          }
          i {
            color: #e6a23c;
          }
          span {
            font-size: 12px;
            cursor: pointer;
          }
        }
      }
      > div {
        padding: 20px;
        background-color: #fff;
        border-radius: 12px;
        position: relative;
        overflow: hidden;
      }
      > div:nth-child(1) {
        width: 540px;
        .upload {
          margin-top: 20px;
          width: 100%;
          .el-upload {
            width: 100%;
            height: 200px;
          }
          .el-upload-dragger {
            height: 200px;
            background-color: rgba(45, 138, 245, 0.06);
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .uploadbutton {
              p {
                color: rgb(96, 98, 102);
                font-size: 14px;
                text-align: center;
                margin-top: 12px;
              }
            }
          }
          .tip {
            font-size: 12px;
            color: #999;
            text-align: center;
            margin-top: 12px;
          }
        }
        .role {
          margin-top: 24px;
          .roletitle {
            i {
              color: #e6a23c;
            }
            span {
              color: rgb(51, 51, 51);
              font-size: 12px;
            }
          }
          .lists {
            display: flex;
            flex-wrap: wrap;
            margin-top: 14px;
            gap: 10px;
            li {
              flex: 0 0 23%;
              position: relative;
              div {
                width: 100%;
                height: 100px;
                overflow: hidden;
                border-radius: 9px;
                position: relative;
                video {
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                  display: block;
                  width: 100%;
                  // height: 100%;
                  cursor: pointer;
                  position: relative;
                  z-index: 10;
                }
              }
            }
            .on::after,
            li:hover::after {
              content: "";
              display: block;
              position: absolute;
              background-image: linear-gradient(
                106.92deg,
                rgb(16, 197, 254) 14.83%,
                rgb(16, 147, 254) 31.52%,
                rgb(79, 79, 231) 65.11%,
                rgb(182, 12, 185) 91.29%,
                rgb(224, 202, 245) 102.83%
              );
              border-radius: 9px;
              width: 104%;
              height: 104%;
              top: -2%;
              left: -2%;
              z-index: 2;
            }
          }

          .selectbox {
            margin-top: 24px;
            padding-top: 24px;
            border-top: 1px solid rgb(244, 245, 247);
            ul {
              display: flex;
              align-items: center;
              margin-bottom: 24px;
              li:nth-child(1) {
                width: 80px;
                margin-right: 10px;
                font-size: 14px;
                color: #333;
                display: flex;
                align-items: center;
                i {
                  color: rgb(228, 231, 237);
                  font-size: 16px;
                }
              }
            }
          }
        }
      }
      > div:nth-child(2) {
        flex: 1 0 10%;
        .tab {
          margin-top: 20px;
          padding: 4px;
          background-color: #f4f5f7;
          border-radius: 40px;
          ul {
            display: flex;
            li {
              flex: 0 0 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #666;
              cursor: pointer;
              height: 44px;
              z-index: 1;
            }
            .on {
              color: #333;
              background-color: #fff;
              border-radius: 40px;
            }
          }
        }
        .tabbox1 {
          margin-top: 24px;
          .button{
            width: 200px;
            margin: 40px auto 0;
            background-image: linear-gradient(
                106.92deg,
                rgb(16, 197, 254) 14.83%,
                rgb(16, 147, 254) 31.52%,
                rgb(79, 79, 231) 65.11%,
                rgb(182, 12, 185) 91.29%,
                rgb(224, 202, 245) 102.83%
            );
            height: 42px;
            padding: 0 20px;
            border: 0;
            border-radius: 6px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 16px;
          }
          .el-textarea {
            background: #f4f5f7;
            border: 1px solid #f4f5f7;
            border-radius: 8px;
            padding: 10px;
            .el-textarea__inner {
              position: relative;
              --el-fill-color-blank: transparent;
              height: 100%;
              background-color: transparent;
              border: none;
            }
          }
          .type {
            display: flex;
            gap: 8px;
            margin-top: 20px;
            li {
              text-align: center;
              padding: 5px 12px;
              border: 1px solid #f4f5f7;
              border-radius: 6px;
              background: #fff;
              flex-shrink: 0;
              cursor: pointer;
              font-size: 14px;
            }
            .on {
              background: #f4f5f7;
            }
          }
          .el-scrollbar {
            height: 300px;
            .el-scrollbar__wrap {
              overflow-x: hidden;
            }
          }
          .usebox {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
            margin-top: 24px;
            li {
              width: 200px;
              height: 48px;
              border: 1px solid #f4f5f7;
              background-color: #f4f5f7;
              border-radius: 8px;
              margin: 5px 0;
              padding: 0 8px;
              cursor: pointer;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: space-betweenc;
              font-size: 14px;
              color: #333;
              img {
                width: 28px;
                margin: 0 8px;
              }
              div:nth-child(3) {
                flex: 1 0 10%;
              }
              div:nth-child(2) {
                margin-right: 12px;
                padding-right: 12px;
                position: relative;
                border-right: 1px solid #ddd;
              }
            }
            .on {
              border: 1px solid #2d8af5;
              background-color: #2d8af5;
              color: #fff;
            }
          }

          .slider {
            display: flex;
            align-items: center;
            width: 350px;
            font-size: 14px;
            border: 1px solid #e6e9ed;
            border-radius: 8px;
            padding: 16px 20px;
            gap: 10px;
            margin-bottom: 10px;
            .el-slider {
              flex: 1 0 10%;
            }
          }
        }
        .tabbox2 {
          margin-top: 20px;
          width: 100%;
          .el-upload {
            width: 100%;
            height: 200px;
          }
          .el-upload-dragger {
            height: 200px;
            background-color: rgba(45, 138, 245, 0.06);
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .uploadbutton {
              p {
                color: rgb(96, 98, 102);
                font-size: 14px;
                text-align: center;
                margin-top: 12px;
              }
            }
          }
          .tip {
            font-size: 12px;
            color: #999;
            text-align: center;
            margin-top: 12px;
          }
        }
      }
    }
  }
}
</style>